// extracted by mini-css-extract-plugin
export var banners = "style-module--banners--03f00";
export var bn = "style-module--bn--673c3";
export var bn20years = "style-module--bn-20years--c9221";
export var bnAllcourses = "style-module--bn-allcourses--9b660";
export var bnBookUU = "style-module--bn-bookUU--b9610";
export var bnEdm = "style-module--bn-edm--7ba34";
export var bnNachaloUU = "style-module--bn-nachaloUU--1380e";
export var bnOfflineUU = "style-module--bn-offlineUU--5e662";
export var bnPlatform = "style-module--bn-platform--1fc24";
export var bnTM = "style-module--bn-TM--b24ce";
export var bnWrap = "style-module--bn-wrap--cd159";
export var btnWrap = "style-module--btn-wrap--b0d09";
export var swiperButtonNext = "style-module--swiper-button-next--73bfd";
export var swiperButtonPrev = "style-module--swiper-button-prev--5e041";
export var white = "style-module--white--4d743";